<template>
  <div class="communityCenter">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="listWrap">
        <div class="list listItem" ref="listItem1">
          <div class="item" v-for="(item, index) in publishlist1" :key="item.id" @click="goEvaluation(item)">
            <div class="logo">
              <img v-lazy="item.coverimg ? (item.coverimg + '?x-oss-process=image/format,jpg') : '/static/images/community/delimg.png'">
              <img class="isvideo" v-if="item.isvideo == 1" src="/static/images/community/video.png">
              <img class="del" src="/static/images/community/delred.png" @click.stop="del(item, index, 1)" />
            </div>
            <div class="desWrap">
              <p class="name over-ell-2">{{item.content}}</p>
              <div class="mt12">
                <p class="f28">{{item.timestr}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="list listItem" ref="listItem2">
          <div class="item" v-for="(item, index) in publishlist2" :key="item.id" @click="goEvaluation(item)">
            <div class="logo">
              <img v-lazy="item.coverimg ? (item.coverimg + '?x-oss-process=image/format,jpg') : '/static/images/community/delimg.png'">
              <img class="del" src="/static/images/community/delred.png" @click.stop="del(item, index, 2)" />
            </div>
            <div class="desWrap">
              <p class="name over-ell-2">{{item.content}}</p>
              <div class="mt12">
                <p class="f28">{{item.timestr}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scroller>
    <div v-if="empty" class="emptybox" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
      <empty v-if="empty" :path="'noIntegral'" :noDatades="3"></empty>
    </div>
  </div>
</template>

<script>
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import empty from '../emptypage/empty'
export default {
  name: 'draftList',
  data () {
    return {
      publishlist1: [],
      publishlist2: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false,
      noDataText: '—— 客官，木有啦~ ——',
      empty: false,
      emptyHeight: 0,
    }
  },
  components: {
    Scroller,
    empty
  },
  mounted: function () {
    this.emptyHeight = document.body.clientHeight
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        if (isWeixin()) fenxiang({path: 'draftlist'})
        vm.publishlist1 = []
        vm.publishlist2 = []
        vm.nowPage = 0
        vm.empty = false
        vm.onInfinite()
      })
    } else {
      next(vm => {
        if (isWeixin()) fenxiang({path: 'draftlist'})
        if (vm.publishlist1.length == 0 && vm.publishlist2.length == 0 && vm.nowPage > 0) {
          vm.publishlist1 = []
          vm.publishlist2 = []
          vm.nowPage = 0
          vm.empty = false
          vm.onInfinite()
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    // 获取列表数据
    getData () {
      var url = 'Wxmall/CommunityPosts/getDraft?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (this.nowPage == 1) {
            this.publishlist1 = []
            this.publishlist2 = []
            this.refresh = false
          }
          this.loading = false
          if (res.data.list.length < this.pagesize) {
            this.finished = true
            if (this.nowPage == 1 && res.data.list.length == 0) {
              this.empty = true
            }
          } else {
            this.finished = false
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.doSort(0, res.data.list)
            })
          })
        }
      })
    },
    formatDate (time) { // 时间格式化 2019-09-08
      let month, day

      month = time.getMonth() + 1 >= 10 ? (time.getMonth() + 1) : ('0' + (time.getMonth() + 1))
      day = time.getDate() >= 10 ? time.getDate() : ('0' + time.getDate())

      return month + '-' + day
    },
    doSort (index, list) {
      console.log(index)
      if (index < list.length) {
        list[index].timestr = new Date(list[index].time) != 'Invalid Date' ? this.formatDate(new Date(list[index].time)) : ''
        if (this.$refs.listItem1.clientHeight <= this.$refs.listItem2.clientHeight) {
          this.publishlist1.push(list[index])
        } else {
          this.publishlist2.push(list[index])
        }
        if (index < list.length - 1) {
          this.loading = true
        } else {
          this.loading = false
        }
        let that = this
        this.$nextTick(() => {
          setTimeout(() => {
            that.doSort(index + 1, list)
          }, 100)
        })
      }
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getData()
    },
    goEvaluation: function (item) {
      this.$router.push({
        path: '/communityevaluation',
        query: {
          id: item.itemid
        }
      })
    },
    // 删除
    del (item, index, type) {
      this.$dialog.confirm({
        message: '确认删除该草稿吗？',
        className: 'collect_button_alert',
        confirmButtonColor: '#FFFCFC',
        cancelButtonColor: '#FC0324',
        closeOnPopstate: true
      }).then(() => {
        var url = 'Wxmall/CommunityPosts/deletePosts'
        var data = {
          itemid: item.itemid
        }
        customRequestAjax.post(url, data).then(res => {
          if (res.data.code == 200) {
            if (type == 1) {
              this.publishlist1.splice(index, 1)
            } else {
              this.publishlist2.splice(index, 1)
            }
            if (this.publishlist1.length + this.publishlist2.length == 0) {
              this.finished = true
              if (this.nowPage == 1) {
                this.empty = true
              }
            }
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.communityCenter {
  font-size: 0.13rem;
  .listWrap {
    width: 100%;
    padding-right: 0.1rem;
    overflow: hidden;
    .list {
      padding-left: 0.1rem; // 剧中
      width: 50%;
      float: left;
      .item {
        margin: 0.1rem 0;
        .logo {
          position: relative;
          height: 1.67rem;
          border-radius: 0.04rem 0.04rem 0 0;
          overflow: hidden;
          display: flex;
          align-items: center;
          background: #fff;
          img {
            width: 100%;
            /*height: 100%;*/
          }
          .del {
            z-index: 100;
            position: absolute;
            right: 0.08rem;
            bottom: 0.05rem;
            width: 0.18rem;
            height: 0.18rem;
          }
        }
        .desWrap {
          padding: 0.08rem 0.1rem 0.12rem;
          background: #fff;
          border-radius: 0 0 0.04rem 0.04rem;
          .mt12 {
            margin-top: 0.12rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/draftList.vue